/* 列傳另外做的人物（不在武將名單裡的）：kit.ts 的 PEOPLE 和各列傳 *_kit.ts 匯出的人物，集中成一份名冊
 * 列傳選單的武將小圖用它畫；不具名的角色（群臣、醫、丞相……）不列。 */
// @ts-nocheck
import * as kit from './kit.ts';
import * as ganning from './story/ganning_kit.ts';
import * as guanzhang from './story/guanzhang_kit.ts';
import * as luxun from './story/luxun_kit.ts';
import * as machao from './story/machao_kit.ts';
import * as simayi from './story/simayi_kit.ts';
import * as taishici from './story/taishici_kit.ts';
import * as xiahouyuan from './story/xiahouyuan_kit.ts';
import * as zhaoyun from './story/zhaoyun_kit.ts';
import * as zhouyu from './story/zhouyu_kit.ts';

export const KITS = { kit, ganning, guanzhang, luxun, machao, simayi, taishici, xiahouyuan, zhaoyun, zhouyu };
const NAMELESS = new Set(['群臣', '醫', '丞相', '吳將', '麻保賊帥', '許貢門客']);
const isPerson = (v) => v && typeof v === 'object' && typeof v.id === 'string' && typeof v.name === 'string' && Array.isArray(v.skills) && v.role && !NAMELESS.has(v.name);

// 每個 kit：「匯出名.鍵」→ 人物，例如 kit 的 PEOPLE.handang、guanzhang 的 GZ.yanyan（測試用它從章節檔找出登場的人物）
export const REFS = {};
for (const [name, K] of Object.entries(KITS)) {
  const R = (REFS[name] = {});
  for (const [ex, obj] of Object.entries(K)) {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) continue;
    for (const [k, v] of Object.entries(obj)) if (isPerson(v)) R[ex + '.' + k] = v;
  }
}
// id → 人物
export default Object.fromEntries(Object.values(REFS).flatMap((R) => Object.values(R)).map((v) => [v.id, v]));
